import React from "react";
import { useNavigate } from "react-router-dom";

const SignUpChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen flex justify-center items-center px-5 bg-gradient-to-br from-[#f7faff] to-[#e8f0ff]">
  {/* Logo */}
  <div className="absolute top-5 left-5">
    <a href="https://styleuai.com/">
      <img
        src="/logo.png"
        alt="StyleAI Logo"
        className="h-7 w-auto drop-shadow-md hover:scale-105 transition-transform duration-300"
      />
    </a>
  </div>

  {/* Card */}
  <div className="w-full max-w-[420px] bg-white p-10 rounded-2xl shadow-[0_12px_35px_rgba(0,0,0,0.08)] text-center">
    <h2 className="text-[26px] font-bold text-[#111827] mb-2 sm:text-[28px]">
      Join StyleUAI
    </h2>
    <p className="text-[15px] text-[#6b7280] mb-8 sm:text-[16px] sm:mb-9">
      Choose how you want to sign up
    </p>

    <div className="flex flex-col gap-4">
      <button
        onClick={() => navigate("/signup/brand")}
        className="py-3.5 px-5 rounded-xl text-[16px] font-semibold text-white bg-[#6c63ff] hover:opacity-90 transition sm:text-[15px] sm:py-[15px] sm:px-[23px] sm:rounded-[14px]"
      >
        Sign Up as Brand
      </button>
      <button
        onClick={() => navigate("/influencer/form")}
        className="py-3.5 px-5 rounded-xl text-[16px] font-semibold text-[#6c63ff] border-2 border-[#6c63ff] bg-white hover:bg-[#f0f0ff] transition sm:text-[15px] sm:py-[15px] sm:px-[23px] sm:rounded-[14px]"
      >
        Sign Up as Influencer
      </button>
    </div>
  </div>
</div>

  );
};

export default SignUpChoice;
